import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#C6C6D6",
      d: "M2.39 8.157 8 13.767l5.611-5.61a3.606 3.606 0 0 0-5.1-5.1l-.51.51-.51-.51a3.606 3.606 0 0 0-5.1 5.1"
    }, null, -1)
  ])))
}
export default { render: render }